// Mock data for Competitive Careers landing page clone

export const ACCREDITATIONS = [
  "British Council Listed",
  "UKVI Agent · 1 of 7 in India",
  "QEAC No. 8051",
  "NAFSA Member 85582",
  "IEAA Member 101279",
  "ICEF Screened IAS 5610",
  "Oxford Global Platinum Agent",
  "AAERI Active Member",
  "Canada Agent CCG00015",
  "Education New Zealand Trained",
  "IELTS · PTE · TOEFL · LanguageCert Official Centres",
  "Pioneer Awards 2020 Finalist",
];

export const DESTINATIONS = [
  {
    flag: "\uD83C\uDDE6\uD83C\uDDFA",
    name: "Australia",
    tagline: "World-class universities",
    image: "https://images.pexels.com/photos/1619854/pexels-photo-1619854.jpeg?auto=compress&cs=tinysrgb&w=900",
    perks: [
      "Post-study work visa",
      "Top-ranked institutions",
      "PR pathways available",
    ],
  },
  {
    flag: "\uD83C\uDDEC\uD83C\uDDE7",
    name: "United Kingdom",
    tagline: "1–2 year fast degrees",
    image: "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg?auto=compress&cs=tinysrgb&w=900",
    perks: [
      "Graduate Route visa",
      "Russell Group access",
      "Affordable scholarships",
    ],
  },
  {
    flag: "\uD83C\uDDF3\uD83C\uDDFF",
    name: "New Zealand",
    tagline: "Safe & welcoming",
    image: "https://images.pexels.com/photos/1462011/pexels-photo-1462011.jpeg?auto=compress&cs=tinysrgb&w=900",
    perks: [
      "Post-study work visa",
      "Peaceful campuses",
      "High graduate employability",
    ],
  },
];

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Fill the 2-minute eligibility form",
    desc: "Tell us about your destination, intake and English test status. No fees, no obligation.",
  },
  {
    n: "02",
    title: "Get your university shortlist & plan",
    desc: "A certified counsellor matches your profile to AU/UK/NZ universities and reviews your cashback eligibility.",
  },
  {
    n: "03",
    title: "Enrol through CCPL and book your exam",
    desc: "We file your applications, SOPs, documents and visa — zero processing fees from our side.",
  },
  {
    n: "04",
    title: "Receive your EXAM FEE cashback",
    desc: "After enrolment confirmation, we refund your IELTS / PTE / TOEFL / LanguageCert exam fee. Simple.",
  },
];

export const STATS = [
  { value: "23+", label: "Years Since 2003" },
  { value: "8,000+", label: "Visa Approvals" },
  { value: "93%", label: "Visa Success Rate" },
  { value: "600+", label: "Partner Universities" },
  { value: "7", label: "Offices Across India" },
];

export const CREDENTIALS = [
  { title: "Oxford International", badge: "Award", desc: "Global Platinum Agent" },
  { title: "British Council & UKVI", badge: "Exclusive", desc: "Both Directors Certified · 1 of 7 in India" },
  { title: "CM of Gujarat Award", badge: "Honour", desc: "TV9 ACE Achiever Award" },
  { title: "QEAC No. 8051", badge: "Certified", desc: "Australia · Director Rupesh Patel" },
  { title: "ICEF Screened Agency", badge: "Verified", desc: "IAS No. 5610" },
  { title: "Pioneer Awards 2020", badge: "Finalist", desc: "Education Agency of the Year Finalist" },
  { title: "NAFSA 85582 · IEAA 101279", badge: "Members", desc: "International Education Memberships" },
  { title: "Eduspana · Spain Govt.", badge: "Rare", desc: "1 of 16 Indian Consultants Invited" },
  { title: "Canada Agent CCG00015", badge: "Authorised", desc: "Education New Zealand Trained" },
];

export const AWARDS = [
  { title: "TV9 ACE Achiever Award", sub: "CM Shri Vijay Rupani · 2019" },
  { title: "MY FM 94.3 Excellence Award", sub: "Excellence in Foreign Education" },
  { title: "Brunel University London", sub: "Agent Award" },
  { title: "Pioneer Awards 2020", sub: "Education Agency of the Year Finalist" },
];

export const TESTIMONIALS = [
  {
    initials: "PS",
    name: "Priya Sharma",
    meta: "University of Melbourne, Australia · 2024",
    quote: "Competitive Careers made my dream of studying in Australia a reality. The counsellors were incredibly transparent and guided me through every step of the visa process. Got my visa approved in just 3 weeks!",
  },
  {
    initials: "RP",
    name: "Rahul Patel",
    meta: "University of Greenwich, UK · 2024",
    quote: "After trying two other consultants, I came to CCPL and they immediately identified the right program for my profile. Everything from SOP to visa was explained so clearly. Highly recommend!",
  },
  {
    initials: "MJ",
    name: "Meera Joshi",
    meta: "University of Manchester, UK · 2023",
    quote: "The team at CCPL is simply the best. 100% transparent, zero hidden fees. They helped me from university selection to SOP to visa interview prep. My visa was approved without any issues.",
  },
  {
    initials: "AS",
    name: "Arjun Shah",
    meta: "Monash University, Australia · 2024",
    quote: "I was nervous about the entire process but the counsellors at Competitive Careers made it so easy. They are always available on WhatsApp and email. Got admission in my first choice university!",
  },
  {
    initials: "AD",
    name: "Ananya Desai",
    meta: "University of Auckland, New Zealand · 2023",
    quote: "Being awarded by the Chief Minister is not just for show — the quality of service here is genuinely exceptional. My entire family recommends Competitive Careers to everyone we know.",
  },
  {
    initials: "KM",
    name: "Karan Mehta",
    meta: "RMIT University, Australia · 2024",
    quote: "Rup sir and the team are absolute legends. They found me a university that perfectly matched my budget, grades, and career goals. And the IELTS coaching was genuinely FREE. Just wow.",
  },
];

export const FAQS = [
  {
    q: "How does the exam fee cashback work?",
    a: "Pay your IELTS / PTE / TOEFL / LanguageCert exam fee as usual. Once your enrolment for an Australia, UK or New Zealand university through CCPL is confirmed, we refund the exam fee of your latest attempt. You'll need to share the official exam fee receipt — or your score report if the receipt isn't available.",
  },
  {
    q: "I have appeared for the exam multiple times — which attempt is refunded?",
    a: "Only the latest attempt's fee is eligible for cashback. Earlier attempts are not refunded.",
  },
  {
    q: "I already applied through another agent — can I still claim the cashback?",
    a: "Yes. If you switch your existing application to CCPL (change of agent) and complete the remaining process — application, SOP, documentation, visa filing and final enrolment — through us, you qualify for the cashback.",
  },
  {
    q: "What is the eligibility condition for this offer?",
    a: "Three things must happen: (1) you receive your university offer letter via CCPL or switch your agent to CCPL, (2) the whole application, SOP, documentation and visa filing is done through CCPL, and (3) you enrol at a university in Australia, UK or New Zealand through CCPL.",
  },
  {
    q: "Will I be charged for visa filing, SOP or applications?",
    a: "No. University shortlisting, SOP writing, document checklist, application filing and student visa filing are handled by our team at zero processing cost.",
  },
  {
    q: "Do I need to visit Ahmedabad for the application process?",
    a: "Not at all. The entire process — online application, document review and counselling — is available from any city in India.",
  },
  {
    q: "How quickly will someone reach out after I submit the form?",
    a: "You'll hear from us on WhatsApp within working hours of submitting the eligibility form.",
  },
  {
    q: "What if my visa is rejected — do I still get the cashback?",
    a: "The cashback is paid after enrolment is confirmed. If the visa is rejected and you do not enrol, the cashback condition isn't met. Our team works hard on visa filing — our success rate is 93%.",
  },
  {
    q: "Are there any hidden conditions I should know about?",
    a: "No hidden conditions. The three conditions are listed above, and verification simply requires your official exam fee receipt or original score report. Terms apply — your counsellor will walk you through the fine print before you commit.",
  },
];

export const WHATSAPP_URL = "https://wa.me/919824027940?text=Hi%20Competitive%20Careers%20team!%20I%27d%20like%20to%20know%20more%20about%20the%20EXAM%20FEE%20CASHBACK%20offer.";
export const PHONE = "+91 98240 27940";
export const PHONE_TEL = "+919824027940";
